import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { tenantsStoreAreAdditionalScriptsLoadedSelector } from '../../redux/tenant-store/tenant-store.selectors.dynamic';
import { CustomInkFooter as CustomInkFooterComponent } from './custom-ink-footer';
const selectors = createStructuredSelector({
  isLoaded: tenantsStoreAreAdditionalScriptsLoadedSelector
});
const connector = connect(selectors);
export const CustomInkFooter = connector(CustomInkFooterComponent);